import { FC } from 'react';

import Card, { CardProps } from '@mui/material/Card';
import Grid from '@mui/material/Grid';

const GridCard: FC<CardProps> = ({ children, ...props }) => (
  <Grid item xs={12} sm={9} md={6} lg={4} xl={3} sx={{ minWidth: '360px' }}>
    <Card {...props}>{children}</Card>
  </Grid>
);

export default GridCard;
